export const emptyStart : string =
    `Metadata:
  lang: en
  title: MyReport
  description:
    My Description
  versionMajor: 0
  versionMinor: 1
  reportVersion: v1
ReportOutput:
  - text: "{reportSummary}"
Components:`;

export const DefaultValues = {
  emptyYaml: `${emptyStart}



- Summary:
    id: reportSummary
    reportTemplate:
    - text: | 
        <em>Use braces to include variables or expressions, e.g. </em><mono>{'{<variable>}'}</mono>
        <em>In smart filter mode, parts with references to undefined variables are removed. Eg.</em>

        Value: "{'text'}" is part of the report, while value: {null} isn't. 
        Not included row due to row condition separated by dubble-pipe || {null}
        This was all for now. || {[undefined,"included if any item is not false or null"]}
  `,
  emptyScript:`EventHandler.OnStateChange = function(get, set, extensions) {
  // Define global update scripts here (runs on change for all components)
  // extensions: { getReason()/* => reason for scope change*/, isReason(componentId: string) /*=> true/false*/ getAllIds()/* => all component identifiers */, getProviderData()/* => provider-data */}
  //get('componentId', 'property') - i.e. get('x','value')
}

EventHandler.OnDataProviderRetrieve = function(get, set, data) {
  // Optionally manually set component properties based on provider data retrieved
  //set('PatientAge', 'value', data[0].providerData[0].properties.patientage);
}

EventHandler.OnBeforeGetState = function(get, set, extensions) {
  // Execute this code before returning the current form state.
}
`,
  demoYaml:`${emptyStart}
- Row:
    label: Patient gender
    components: 
    - Option:
        id: PatientSex
        dataarg: SectraIds7.PatientSex
        options:
        - text: Male
          value: M
          description: Gender is male
        - text: Female
          value: F
          description: Gender is female
        - text: Other
          value: O
          description: Gender is something else
    - HR: {}
- Row:
    label: Exam description
    components:
    - Text:
        id: Ex1
        dataarg: SectraIds7.ExamDescription
        placeholder: Provide a mandatory exam description here
        value: =If(Eq(PatientSex, 'M'), 'Male gender override...')
        disabled: =Eq(PatientSex, 'M')
        display: =Not(Eq(PatientSex, 'O'))
        mandatory: alert
        suffix: =If(Not(Eq(PatientSex, 'F')), 'x')
    - Text:
        id: Ex2
        placeholder: Provide something else here
        value: =IfEmpty(PatientSex, 'No gender?')
        display: =Not(Eq(PatientSex, 'F'))
        mandatory: alert
- Text:
    id: Free1
    placeholder: Demo of text component without a row container
- Row:
    label: Preset value
    components:
    - Text:
        id: Text1
        value: Value from specification
- Row:
    label: Yes/no and reason
    components: 
    - Option:
        id: BoolOpt
        optionLayout: fill-equal
        size: m
        options:
        - text: Yes
          value: true
        - text: No
          value: false
    - Dropdown:
        id: Drop1Yes
        display: =BoolOpt
        placeholder: Specfiy why?
        options:
        - Option 1
        - Option 2
    - Dropdown:
        id: Drop1No
        display: =BoolOpt==false
        placeholder: Specfiy why not?
        options:
        - Option 1
        - Option 2
    - Button:
        label: Set as Yes
        display: =Not(BoolOpt)
        onClick: set("BoolOpt", "value", true)
- Row:
    id: checkForFullWithRow
    label: Check for full-width
    checkbox: true
    checkboxFunc: none
    fullWidth: =checkForFullWithRow
    components:
    - Dropdown:
        id: MediumDrop
        placeholder: Medium drop
        size: m
        options:
        - Option 1
        - Option 2
    - Dropdown:
        id: LargeDrop
        placeholder: Large drop
        size: l
        options:
        - Option 1
        - Option 2
    - Dropdown:
        id: FullWidthDrop
        placeholder: Full width Drop
        size: fill
        options:
        - Option 1
        - Option 2
    - Header:
        header: In row header
        level: h4
    - TextArea:
        id: TestRowContextTA
        placeholder: Text area inside row context
- Row:
    label: Check to display row children
    checkbox: true
    spacing: tight
    components:
    - Number:
        id: test
        size: m
        placeholder: Size 
    - RowBreak: {}
    - Text:
        id: checkableRowValue
        placeholder: This is a checkable row
- VSpace:
    space: s
- Row:
    label: Multichoice (one or several)
    components:
    - Option: 
        id: multichoice
        multichoice: true
        options: 
          - A
          - B
          - C
- Row:
    label: Values on next row (to facilitate many options)
    fullWidth: true
    components:
    - Option:
        id: option4
        options:
        - Opt1
        - Opt2
        - Opr3
        - Opt4
        - Opt5
        - Opr6
        - Opt7
        - Opt8
        - Opr9
        - Opt10
- HR: {}
- Header: 
    header: Further examples in tabs
- SectraTab:
    id: demoTabs
    tabs: 
    - tabname: Lists
      components:
      - Button:
          label: Enter lesion data
          color: warning
          onClick: set("TestList1Zone", "value", "Pz"), set("TestList1SizeW", "value", 12), set("TestList1SizeH", "value", 11), set("TestList1SizeD", "value", 13), set("TestList1SizeComment", "value", "Automatic set of data")
      - Checkbox:
          id: registerLesions
          label: Register lesions
          value: true
      - List:
          id: TestList
          itemName: Lesion {index}
          addButtonText: Add new item
          minCount: 1
          maxCount: 3
          display: registerLesions||init=true
          collapseSummary: "{Size.label}: {Size}, {SizeComment.label}: {SizeComment}"
          components:
          - Row:
              label: Zone
              components: 
              - Option:
                  id: Zone
                  options:
                  - Pz
                  - Tz
                  - Pz (Tz)
                  - Tz (Pz)
                  - Cz
          - Row:
              label: Size
              components:
              - Number:
                  id: SizeW
                  suffix: x
                  placeholder: W
                  size: xs
                  minValue: 0
              - Number:
                  id: SizeH
                  suffix: x
                  placeholder: H
                  size: xs
                  minValue: 0
              - Number:
                  id: SizeD
                  suffix: mm
                  placeholder: D
                  size: xs
                  minValue: 0
              - Text:
                  id: Size
                  hidden: true
                  value: =getSize(SizeW, SizeH, SizeD)
          - Row:
              label: Static text test
              components:
              - StaticText:
                  value: =Size
                  formatter: "The lesion size is: {value}"
                  emptyFormatter: "No size available"
          - Row:
              label: Size comment
              components:
              - Text:
                  id: SizeComment
                  value: Size comment 
      - List:
          id: QualityComments
          collapsable: false
          itemName: Quality comment {index}
          addButtonText: + Add new quality comment
          numItems: 1
          maxCount: 3
          components:
          - Row:
              label: Type
              components: 
              - Dropdown:
                  id: QualityCommentType
                  placeholder: Please choose a type
                  name: Quality comment type
                  mandatory: prohibit
                  options:
                  - Type 1
                  - Type 2
                  - Type 3
                  uniqueInRepeatedElements: true
          - Row:
              label: Comment
              components: 
              - Text: 
                  id: Comment
                  name: Quality comment text
                  mandatory: prohibit
                  placeholder: Add a quality comment here of type
    - tabname: Report
      components:
      - Summary:
          id: reportSummary
          reportTemplate:
          - text: | 
              This is an example of a smart report. The report will contain additional items if they are defined.
              This line will be visible if there's an exam description||{Ex1}
              This is the report. Patient gender is {PatientSex}.
              Yes/no answer: {BoolOpt.displayValue} - {If(BoolOpt,Drop1Yes,Drop1No)}
              Multichoice: {multichoice}

                            
              Tables can be used in the output. This however requires IDS7 24.2 or newer and that the form has reportVersion set to v2 in the Metadata section.
              {ToTable([['row1 col1','row1 col2','row1 col3'], ['row2 col1', 'row2 col2', 'row2 col3'], [PatientSex, BoolOpt.displayValue, multichoice]])}
              If targetting IDS7 24.1 or older ASCII tables can be used instead:
              <pre>{ToASCITable([['row1 col1','row1 col2','row1 col3'], ['row2 col1', 'row2 col2', 'row2 col3'], [PatientSex, BoolOpt.displayValue, multichoice]], "simpleb", false)}</pre>

    - tabname: SectorMap
      components:
      - Row:
          fullWidth: true
          components:   
          - StaticText:
              emptyFormatter: "Please mark the lesion below"
              formatter: "Sector: {value}"
              value: =ArrayFormat1(prostateCanvas.sectorArray)
      - Painter:
          id: prostateCanvas
          posAlignment: left
          width: 500
          darkSvgColor: 
          - type: fill
            color: "#bbb"
          - type: stroke
            color: "#fff"
          lightSvgColor: 
          - type: fill
            color: "#444"
          - type: stroke
            color: "#000"
          image: data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2400 2740'%3E%3Cstyle%3E.a%7Bfill:none;stroke-width:6;stroke:%23000%7D.b,.c,.d,.e,.f,.g,.h%7Bfill:none;stroke-width:4;stroke:%23000%7D.c,.d,.e,.f,.g,.h%7Bstroke-dasharray:30.8%7D.d,.e,.f,.g,.h%7Bstroke-dasharray:31.4;stroke:%23000%7D.e,.f,.g,.h%7Bstroke-dasharray:31.5%7D.f,.g,.h%7Bstroke-dasharray:32.9%7D.g,.h%7Bstroke-dasharray:31.7%7D.h%7Bstroke-dasharray:31%7D.i,.j%7Bfont-family:open_sans, 'Segoe UI', 'Trebuchet MS', Helvetica, Arial, sans-serif;font-weight:normal;font-size:60px;fill:%23000;stroke:none%7D.j%7Bfont-size:85px;text-align:center;text-anchor:middle%7D%3C/style%3E%3Cpath d='M1945 2330c-4.1-42.2-20.3-71.5-24-78-18.1-31.7-40.8-49.8-54-60-23.1-18-44.1-27.2-60-34-9-3.9-68-26-112-26s-103 22.1-112 26c-15.9 6.8-36.9 16-60 34-13.2 10.2-35.9 28.3-54 60-3.7 6.5-19.9 35.8-24 78-5.5 55.9 13.6 98 24 120 1.5 3.2 17.7 37 47 64 10.1 9.3 20 16.2 33 19 11.9 2.6 22.5.9 27 0 7.9-1.6 8.6-3.3 26-10 5.2-2 14.6-5.6 26-9 7.1-2.1 17.1-5 30-7 9.3-1.4 28-2 37-2s27.7.6 37 2c12.9 2 22.9 4.9 30 7 11.4 3.4 20.8 7 26 9 17.4 6.7 18.1 8.4 26 10 4.5.9 15.1 2.6 27 0 13-2.8 22.9-9.7 33-19 29.3-27 45.5-60.8 47-64 10.4-22 29.5-64.1 24-120z' class='a'%3E%3C/path%3E%3Cpath class='b' d='M2164 2415l-15.3-4.8'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='32.7' stroke-width='4' d='M2125.3 2402.8L1816 2305l-121-12-121 12-321 101.5'%3E%3C/path%3E%3Cpath class='b' d='M1241.3 2410.2l-15.3 4.8M1538 2108l2.8 15.7'%3E%3C/path%3E%3Cpath class='c' d='M1545 2146.4l84.1 465.5'%3E%3C/path%3E%3Cpath class='b' d='M1631.2 2623.3l2.8 15.7M1852 2108l-2.8 15.7'%3E%3C/path%3E%3Cpath class='c' d='M1845 2146.4l-84.1 465.5'%3E%3C/path%3E%3Cpath class='b' d='M1758.8 2623.3l-2.8 15.7M1695 2108v16'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='33.8' stroke-width='4' d='M1695 2149.4v460.9'%3E%3C/path%3E%3Cpath class='b' d='M1695 2623v16'%3E%3C/path%3E%3Cpath d='M1992 1515c-4.1-16-12.1-46-34-79-19.5-29.3-40.1-46.1-62-64-16.6-13.5-41.4-33.5-79-50-28.4-12.5-80-29-122-29s-93.6 16.5-122 29c-37.6 16.5-62.4 36.5-79 50-21.9 17.9-42.5 34.7-62 64-21.9 33-29.9 63-34 79-5.5 21.5-16.1 65-4 117 6.7 28.8 17.5 47.6 20 52 13.7 23.5 29.4 37.6 40 47 31.8 28.2 63.1 40.9 86 50 39.2 15.6 112 29 155 29s115.8-13.4 155-29c22.9-9.1 54.2-21.8 86-50 10.6-9.4 26.3-23.5 40-47 2.5-4.4 13.3-23.2 20-52 12.1-52 1.5-95.5-4-117z' class='a'%3E%3C/path%3E%3Cpath class='b' d='M1423 1269l3.3 15.7'%3E%3C/path%3E%3Cpath class='d' d='M1431.2 1307.7l122.1 579.1'%3E%3C/path%3E%3Cpath class='b' d='M1555.7 1898.3l3.3 15.7M1695 1269v16'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='30.7' stroke-width='4' d='M1695 1308v578.5'%3E%3C/path%3E%3Cpath class='b' d='M1695 1898v16M1967 1269l-3.3 15.7'%3E%3C/path%3E%3Cpath class='d' d='M1958.8 1307.7l-122.1 579.1'%3E%3C/path%3E%3Cpath class='b' d='M1834.3 1898.3l-3.3 15.7M2164 1596l-15.5-3.9'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='32.1' stroke-width='4' d='M2125.1 1586.3L1911 1533l-216-15.7-216 15.7-225.8 56.2'%3E%3C/path%3E%3Cpath class='b' d='M1241.5 1592.1l-15.5 3.9'%3E%3C/path%3E%3Cpath d='M2063 745c-3-34.2-11.2-59.7-14-68-5.4-16-18.6-53.4-51-90-32.6-36.7-67.5-53.4-94-66-43.8-20.8-80.9-27.6-112-33-39.2-6.8-72-8-97-8s-57.8 1.2-97 8c-31.1 5.4-68.2 12.2-112 33-26.5 12.6-61.4 29.3-94 66-32.4 36.6-45.6 74-51 90-2.8 8.3-11 33.8-14 68-2.3 26.5-.5 46.7 1 62 2.3 23.6 3.9 40.1 12 61 3.9 10.1 9.8 24.8 23 40 3.5 4 12.1 13.4 32 26 25.7 16.3 49.1 24.6 63 29 35 11.2 65.3 15.7 95 19 35.9 4 86 7 142 7s106.1-3 142-7c29.7-3.3 60-7.8 95-19 13.9-4.4 37.3-12.7 63-29 19.9-12.6 28.5-22 32-26 13.2-15.2 19.1-29.9 23-40 8.1-20.9 9.7-37.4 12-61 1.5-15.3 3.3-35.5 1-62z' class='a'%3E%3C/path%3E%3Cpath class='b' d='M1695 457v16'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='33.3' stroke-width='4' d='M1695 497.9v569.6'%3E%3C/path%3E%3Cpath class='b' d='M1695 1080v16M1370 457l4.2 15.5'%3E%3C/path%3E%3Cpath class='e' d='M1380.3 495.3l154.5 573.8'%3E%3C/path%3E%3Cpath class='b' d='M1537.8 1080.5l4.2 15.5M2020 457l-4.2 15.5'%3E%3C/path%3E%3Cpath class='e' d='M2009.7 495.3l-154.5 573.8'%3E%3C/path%3E%3Cpath class='b' d='M1852.2 1080.5l-4.2 15.5M2164 773l-15.7-3'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='31.8' stroke-width='4' d='M2124.8 765.5L1946 731l-251-8-251 8-190.7 40.2'%3E%3C/path%3E%3Cpath class='b' d='M1241.7 773.7L1226 777M497 2586c0-58.9 2.6-120.1-10-178-1.5-7-3.8-16.2-9-27-6.1-12.7-13.5-22-19-28M625 2353c-5.5 6-12.9 15.3-19 28-5.2 10.8-7.5 20-9 27-12.6 57.9-10 119.1-10 178'%3E%3C/path%3E%3Cpath d='M524 2385c-38.1-16.4-68.6-33.8-91-48-26.9-17.1-59.3-37.9-94-74-24.8-25.8-40.1-48.2-44-54-33-49.1-45.5-93.1-49-106-9.9-36.9-10.8-65.7-11-72-1-38.1 5.7-67.5 9-80 2.1-7.9 19.8-73.3 65-116 14.6-13.8 26.8-20.3 37-24 5.5-2 18.6-6.3 36-6 7.8.1 27.7.7 48 13 15.5 9.4 23.7 21 32 33 5.1 7.3 14.9 22.8 24 52 8.7 27.7 10.8 49 14 82 2.3 23.7 4.5 46.4 4 77-.4 24.3 2.4 48.7 1 73-.2 4.3-1 15.5 4 28 1.2 3 4.8 11.5 13 20 7.4 7.7 14 14 20 14s12.6-6.3 20-14c8.2-8.5 11.8-17 13-20 5-12.5 4.2-23.7 4-28-1.4-24.3 1.4-48.7 1-73-.5-30.6 1.7-53.3 4-77 3.2-33 5.3-54.3 14-82 9.1-29.2 18.9-44.7 24-52 8.3-12 16.5-23.6 32-33 20.3-12.3 40.2-12.9 48-13 17.4-.3 30.5 4 36 6 10.2 3.7 22.4 10.2 37 24 45.2 42.7 62.9 108.1 65 116 3.3 12.5 10 41.9 9 80-.2 6.3-1.1 35.1-11 72-3.5 12.9-16 56.9-49 106-3.9 5.8-19.2 28.2-44 54-34.7 36.1-67.1 56.9-94 74-22.4 14.2-52.9 31.6-91 48' class='a'%3E%3C/path%3E%3Cpath d='M542 1971c2.5 0 5.5-8.3 8-15 2.3-6.1 11.8-69 13.8-80 .1-.3.1-.7.2-1 2.5-13.4 7.4-35.9 8-39 2.7-13.3 4-21.5 4-31 0-11.2-1.7-13.2-1-23 .3-4.7 1.2-15.5 7-27 4.2-8.5 9.8-14.3 21-26 8.8-9.2 10.1-9.2 13-14 1.8-3 4.3-8.1 7-26 2.7-17.8.8-17.2 3-26 1.6-6.3 4.5-18.1 14-28 4.9-5.2 10.2-8.2 20-14 9.4-5.5 10.7-5 16-9 8.3-6.2 13-13.3 16-18 7.2-11.2 4.9-13.3 12-26 3.6-6.4 8.6-15.4 18-23 5.4-4.4 6.8-3.8 24-12 22.8-10.9 23.5-13.3 34-16 4-1 3.1-.5 26-3 17.8-2 26.8-3 32-4 15.2-3 17.1-5.4 31-7 11.1-1.3 17.1-.7 21 0 3.7.6 10.6 2.1 18 6 2.5 1.3 24.5 13.1 31 38 1.1 4 3.1 12.1 1 22-.5 2.4-1.5 5.8-7 16-7 12.9-13.9 23-19 30-7.8 10.8-8.9 14.5-14 18-4.1 2.9-5.1 2.2-13.5 6.5-3.5 1.8-11 5.7-19 12-5.8 4.5-11.2 8.8-16 16-6.7 10-3.9 13.4-10 22-4.2 5.9-9.4 9.3-20 16-9.1 5.8-15.9 10.1-26 13-6.8 1.9-10 1.7-20 5-8.4 2.7-12.5 4.9-15 9-1.7 2.8-.9 3.8-3 8-2.3 4.7-5.3 7.5-9 11-1.7 1.6-7.3 6.6-16 11-3.1 1.5-5.9 3-10 4-6.4 1.6-11.1 1.1-15 1-6.8-.2-6.2.7-25 3-21.8 2.6-21.1 1.2-28 3-11.6 3.1-19.5 8.9-25 13-10.4 7.8-20.6 19-31 39-4.9 9.4-13 27.1-24 84-3.7 19.1-6.4 33.4-9 54-3.1 24.8-4.1 50.2-6 101-.4 10.6-.8 21.3-1.1 31.9-.4 10.6-.7 21.3-1.1 31.9-.3 8.6-.6 17.3-.9 25.9-.1 2.8-.2 5.5-.4 8.3-.1 2 0 4.1-.5 6.1-.5 2.5-2.1 4.5-3.3 6.6-2.2 3.6-4.9 7.7-9.7 7.4h-1c-4.8.4-7.5-3.7-9.7-7.4-1.3-2.1-2.8-4.1-3.3-6.6-.4-2-.4-4-.5-6.1-.1-2.8-.3-5.5-.4-8.3-.3-8.6-.6-17.3-.9-25.9-.4-10.6-.7-21.3-1.1-31.9-.4-10.6-.7-21.3-1.1-31.9-1.9-50.8-2.9-76.2-6-101-2.6-20.6-5.3-34.9-9-54-11-56.9-19.1-74.6-24-84-10.4-20-20.6-31.2-31-39-5.5-4.1-13.4-9.9-25-13-6.9-1.8-6.2-.4-28-3-18.8-2.3-18.2-3.2-25-3-3.9.1-8.6.6-15-1-4.1-1-6.9-2.5-10-4-8.7-4.4-14.3-9.4-16-11-3.7-3.5-6.7-6.3-9-11-2.1-4.2-1.3-5.2-3-8-2.5-4.1-6.6-6.3-15-9-10-3.3-13.2-3.1-20-5-10.1-2.9-16.9-7.2-26-13-10.6-6.7-15.8-10.1-20-16-6.1-8.6-3.3-12-10-22-4.8-7.2-10.2-11.5-16-16-8-6.3-15.5-10.2-19-12-8.4-4.3-9.4-3.6-13.5-6.5-5.1-3.5-6.2-7.2-14-18-5.1-7-12-17.1-19-30-5.5-10.2-6.5-13.6-7-16-2.1-9.9-.1-18 1-22 6.5-24.9 28.5-36.7 31-38 7.4-3.9 14.3-5.4 18-6 3.9-.7 9.9-1.3 21 0 13.9 1.6 15.8 4 31 7 5.2 1 14.2 2 32 4 22.9 2.5 22 2 26 3 10.5 2.7 11.2 5.1 34 16 17.2 8.2 18.6 7.6 24 12 9.4 7.6 14.4 16.6 18 23 7.1 12.7 4.8 14.8 12 26 3 4.7 7.7 11.8 16 18 5.3 4 6.6 3.5 16 9 9.8 5.8 15.1 8.8 20 14 9.5 9.9 12.4 21.7 14 28 2.2 8.8.3 8.2 3 26 2.7 17.9 5.2 23 7 26 2.9 4.8 4.2 4.8 13 14 11.2 11.7 16.8 17.5 21 26 5.8 11.5 6.7 22.3 7 27 .7 9.8-1 11.8-1 23 0 9.5 1.3 17.7 4 31 .6 3.1 5.5 25.6 8 39 .1.3.1.7.2 1 2 11 11.5 73.9 13.8 80 2.5 6.7 5.5 15 8 15M356 1782l2.1 15.9' class='b'%3E%3C/path%3E%3Cpath class='f' d='M361.3 1822.3l73 558.6'%3E%3C/path%3E%3Cpath class='b' d='M435.9 2393.1l2.1 15.9M728 1782l-2.1 15.9'%3E%3C/path%3E%3Cpath class='f' d='M722.7 1822.3l-73 558.6'%3E%3C/path%3E%3Cpath class='b' d='M648.1 2393.1L646 2409M121 2009h16'%3E%3C/path%3E%3Cpath class='g' d='M160.8 2009h765.3'%3E%3C/path%3E%3Cpath class='b' d='M938 2009h16M121 2197h16'%3E%3C/path%3E%3Cpath class='g' d='M160.8 2197h765.3'%3E%3C/path%3E%3Cpath class='b' d='M938 2197h16'%3E%3C/path%3E%3Cpath d='M737.8 460.9c3.8 3 7.7 7.2 13.7 13.6 8.6 9.3 13.6 14.7 18 23 4.5 8.5 6.5 16.4 8 25 5.2 30 2.5 57.5 2 62-4.5 42.5-13 74-13 74-18.6 69.1-28.6 106.1-51 160-26.2 63-44.2 106.3-83 157-43.1 56.3-83.4 84.4-108 99-17.3 10.3-43.6 23.7-76.3 28.5M473.4 480c.6-5.5 1.6-11.8 3.1-18.5 1-4.3 4.1-18.7 10-31 9.7-20.4 25.2-32 39-42 9.4-6.8 52.1-36.6 111-37 23.4-.2 34.6 4.4 40 7 5.6 2.7 27.5 14.2 36 37 9 24.2 8 40 8 40-.1 2.2-.5 6.5.7 10.9M426.4 1104.8c-23.3.3-37-5-43.9-8.3-14.2-6.8-23-15.7-30-23-21.2-22-30.9-45-35-55-27.6-67.6-39-130-39-130-8.2-44.6-17.2-97.4-17-169 .1-43.2 3.6-94.6 20-148 1.3-4.4 11.6-36.8 36-71 14.4-20.1 25.3-29.3 38-35 15.3-6.9 28.9-7 34-7 23.8.1 43.2 10.6 56.2 20.5' class='a'%3E%3C/path%3E%3Cpath d='M528.5 717.4c9.7-6.1 20.7-13.6 32.5-22.4 5.3-4 27.1-20.5 53-46 25-24.6 41.3-45.3 45-50 16.8-21.5 27.8-39.2 35-51 15.2-24.8 25-44.7 28-51 7.9-16.4 16.3-35.8 24-58l11-3c3.9-1.4 9.4-3.5 16-6 15.3-5.8 18.3-7.4 21-9 4.8-2.9 8.5-6.6 16-14 11.4-11.3 17.8-19.8 24-28 3.6-4.8 5.9-8.2 8-13 .9-2.1 3.1-7.6 4-15 .8-6.4-.1-7.9 0-16 .1-8.4 1.2-14.7 2-19 1-5.7 2.7-11.2 6-22 3.8-12.3 5.5-16.8 9-29 2.2-7.7 2.7-10 3-12 .5-2.8 1.2-8 1-21-.1-4.5-.2-11.1-1-20-1.2-13.5-2.4-15.1-2-23 .2-3.3.5-5.4 0-9-.2-1.1-.7-4.4-5-13-2.9-5.8-5.2-10.4-9-16-1.3-1.9-2.1-3-3-5-.4-.9-1.7-4-2-11-.3-5.4.4-4.9 0-9-.3-3.2-.7-6.7-3-10-1.3-1.8-2.7-3-4-4-10.2-7.7-22.1-10.8-27-12-1.5-.4-3.9-.9-7-1-2 0-4.9-.1-8 1-1.4.5-2.4 1.1-9 7-4.6 4.2-5.4 5-8 7-2.1 1.6-3.7 2.8-6 4-3.9 2-4.9 1.5-8 3-5.2 2.5-8 6.6-9 8-1.9 2.8-2.6 5.2-4 10-1.8 6.1-1.5 7.9-3 14-.6 2.5-1.8 7.3-4 12-3.4 7.4-7 9.7-11 15-4 5.3-5.6 10.9-9 22-5.3 17.4-6.7 31.5-8 45-1.1 11.2-1.2 18.6-1 25 .2 6.8.4 12.1 2 19 1.8 7.9 4 14 4 14 1.1 3.1 1.8 4.5 2 7 .5 4.8-1.1 8.7-2 11-2.1 5.1-3.8 5.6-6 10-2.2 4.3-2.5 8-3 13-1 10.7.7 21.5 3 31 1.9 8 5.2 18.8 11 31l3 7c-2.5 9.6-5.1 20.9-10 35-2.4 6.8-9.9 28-23 55-6.2 12.8-15.3 31.4-30 54-17 26.2-32.7 43.9-47 60-14.1 15.8-28.3 31.7-50 50-15.2 12.8-29.5 22.9-41.3 30.5' class='b'%3E%3C/path%3E%3Cpath d='M393 1158c27.1-38.3 45.1-73.7 57-101 18-41.3 26.2-73.9 28-81 5.7-22.8 8.5-46.5 14-93 4.3-36.2 8-72.3 10.6-108.7 1.3-18.6 2.1-37.2 2.2-55.9.2-17.9 1.4-37-2.8-54.4-1.1-4.3-3-8-3-8-1-1.9-2.1-3.4-4-6-3.2-4.3-4.8-6.4-7-9-5.8-6.8-14-22.3-18-30-10.2-19.8-20.5-39.8-24.7-61.8-2.6-13.8-1.1-27.3-1.3-41.2 0-3.6.2-7.2.4-10.8.3-4.9.5-9.8 1-14.7.6-6.4.7-16.6 8.6-18.5 5.3-1.2 10.2 3.2 13.1 7.1 7.4 10.2 14.8 20.8 21.4 31.6 6.7 11 11.8 22.8 18.2 34 13 22.7 21.3 47.1 27.8 72.4.5 2 1 3.9 1.5 5.9 2 7.9 3.7 15.4 3 25-.3 3.7-1.3 7.3-2 11-2.5 11.6-3.8 23.4-6 35-.9 4.6-1.6 8.4-2 14-1.1 16.3.1 32.7-.6 49-.8 16.6-1.9 33.2-3.3 49.8-1.1 13.1-2.5 26.1-4 39.2-6.4 53.7-15.1 93.8-18 107-4 18.2-8.6 38.4-17 65-12.4 39.1-25.2 67-28 73-10.8 23.3-26.5 52.8-49 85M361 1219l3.7-15.6' class='b'%3E%3C/path%3E%3Cpath class='f' d='M370.5 1179.5l197.9-827'%3E%3C/path%3E%3Cpath class='b' d='M571.3 340.6L575 325M281 571l15.3 4.6'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='31.2' stroke-width='4' d='M318.7 582.4L725.5 705'%3E%3C/path%3E%3Cpath class='b' d='M736.7 708.4L752 713M270 839l15.3 4.5'%3E%3C/path%3E%3Cpath fill='none' stroke='%23000' stroke-dasharray='32.4' stroke-width='4' d='M308.6 850.4L623 943'%3E%3C/path%3E%3Cpath class='b' d='M634.7 946.5L650 951M121 523l15.3 4.6'%3E%3C/path%3E%3Cpath class='h' d='M158.6 534.3L927.5 766'%3E%3C/path%3E%3Cpath class='b' d='M938.7 769.4L954 774M121 795l15.3 4.5'%3E%3C/path%3E%3Cpath class='h' d='M158.6 806.1l768.9 227.1'%3E%3C/path%3E%3Cpath class='b' d='M938.7 1036.5l15.3 4.5'%3E%3C/path%3E%3Ctext y='1926.8' x='893.8' class='i'%3EA%3C/text%3E%3Ctext y='2123.8' x='893.8' class='i'%3EB%3C/text%3E%3Ctext y='2321.8' x='893.8' class='i'%3EC%3C/text%3E%3Ctext y='2617.8' x='1639.2' class='i'%3E2%3C/text%3E%3Ctext y='2617.8' x='1559.8' class='i'%3E1%3C/text%3E%3Ctext y='2617.8' x='1718.5' class='i'%3E3%3C/text%3E%3Ctext y='2617.8' x='1797.8' class='i'%3E4%3C/text%3E%3Ctext y='2058.8' x='1676.4' class='i'%3EC%3C/text%3E%3Ctext y='2316.8' x='1262.1' class='i'%3Ev%3C/text%3E%3Ctext y='2524.8' x='1255.5' class='i'%3Ed%3C/text%3E%3Ctext y='1219.8' x='1677.8' class='i'%3EB%3C/text%3E%3Ctext y='1892.8' x='1599.2' class='i'%3E2%3C/text%3E%3Ctext y='1892.8' x='1439.8' class='i'%3E1%3C/text%3E%3Ctext y='1892.8' x='1758.5' class='i'%3E3%3C/text%3E%3Ctext y='1892.8' x='1917.8' class='i'%3E4%3C/text%3E%3Ctext y='1500.8' x='1262.1' class='i'%3Ev%3C/text%3E%3Ctext y='1709.8' x='1255.5' class='i'%3Ed%3C/text%3E%3Ctext y='406.8' x='1675.7' class='i'%3EA%3C/text%3E%3Ctext y='1074.8' x='1599.2' class='i'%3E2%3C/text%3E%3Ctext y='1074.8' x='1439.8' class='i'%3E1%3C/text%3E%3Ctext y='1074.8' x='1758.5' class='i'%3E3%3C/text%3E%3Ctext y='1074.8' x='1917.8' class='i'%3E4%3C/text%3E%3Ctext y='683.8' x='1262.1' class='i'%3Ev%3C/text%3E%3Ctext y='892.8' x='1255.5' class='i'%3Ed%3C/text%3E%3Ctext y='1040.9' x='569' transform='rotate(16.799)' class='i'%3Ev%3C/text%3E%3Ctext y='1040.9' x='785' transform='rotate(16.799)' class='i'%3Ed%3C/text%3E%3Ctext y='661.8' x='893.8' class='i'%3EA%3C/text%3E%3Ctext y='915.8' x='893.8' class='i'%3EB%3C/text%3E%3Ctext y='1167.8' x='893.8' class='i'%3EC%3C/text%3E%3Ctext y='339.8' x='1419.3' class='i'%3ERIGHT%3C/text%3E%3Ctext y='339.8' x='1846.9' class='i'%3ELEFT%3C/text%3E%3Ctext y='230' x='1698.4' class='j'%3EAxial%3C/text%3E%3Ctext y='1483' x='539' class='j'%3ECoronal%3C/text%3E%3Ctext y='230' x='539' class='j'%3ESagittal%3C/text%3E%3C/svg%3E
          sectorMap: 
          # Section A
          - name: 1Av
            polygon: 300,152, 292,120, 280,137, 276,157
          - name: 2Av
            polygon: 353,151, 353,100, 328,102, 301,112, 292,120, 300,152
          - name: 3Av
            polygon: 353,151, 405,152, 414,119, 397,108, 374,102, 353,100
          - name: 4Av
            polygon: 405,152, 430,157, 427,141, 419,125, 414,119
          - name: 1Ad
            polygon: 276,157, 300,152, 314,204, 292,196, 282,187, 277,174
          - name: 2Ad
            polygon: 314,204, 300,152, 353,151, 353,207, 326,205
          - name: 3Ad
            polygon: 353,151, 405,152, 391,203, 375,205, 353,207
          - name: 4Ad
            polygon: 405,152, 430,157, 429,176, 421,192, 404,201, 391,203
          # Section B
          - name: 1Bv
            polygon: 307,319, 302,294, 293,309, 289,324
          - name: 2Bv
            polygon: 307,319, 353,316, 353,269, 332,273, 318,281, 302,294
          - name: 3Bv
            polygon: 353,269, 353,316, 398,319, 403,293, 390,282, 374,273
          - name: 4Bv
            polygon: 398,319, 403,293, 413,308, 417,324, 
          - name: 1Bd
            polygon: 318,371, 307,319, 289,324, 290,338 ,296,354, 304,362
          - name: 2Bd
            polygon: 318,371, 307,319, 353,316, 353,378, 333,375
          - name: 3Bd
            polygon: 353,316, 398,319, 387,371, 369,375, 353,378
          - name: 4Bd
            polygon: 398,319, 417,324, 417,337, 410,355, 387,373
          # Section C
          - name: 1Cd
            polygon: 327,481, 301,488, 303,503, 310,517, 320,529, 335,526
          - name: 2Cd
            polygon: 327,481, 352,477, 353,521, 320,529, 335,526
          - name: 3Cd
            polygon: 352,477, 378,480, 370,525, 353,521
          - name: 4Cd
            polygon: 378,480, 405,488, 403,502, 395,518, 383,528, 370,525
          - name: 1Cv
            polygon: 327,481, 322,453, 309,464, 303,476, 301,488
          - name: 2Cv
            polygon: 327,481, 322,453, 337,447, 352,444, 352,477
          - name: 3Cv
            polygon: 352,477, 352,444, 366,446, 383,453, 378,480
          - name: 3Cv
            polygon: 383,453, 395,462, 401,471, 406,488, 378,480
          sectorMapWidth: 500

 `,

  demoScript:
     `// Define global update scripts here (runs on change for all components)

// Used as calculator for the 'Size'-component
function getSize(w, h, d) {
	var v =[['W', w], ['H', h], ['D', d]].filter(function(x){ return x[1]>0 });
  	return v.length > 0 
      ? v.map(function(x) { return x[1]}).join('x') + ' (' + v.map(function(x) { return x[0]}).join('x') + ')'
      : null 
}

/*
// Example - Conditional hide
if (get('x').value === "base") {
  set('y', 'hidden', true);
}

// Example - Codinationl disable
if (get('y').value === "Male"){
  set('x', 'disabled', true);
}

// Example - A complicated and strange form of autocomplete
var x = get('x').value;
var newX = x;
switch (x) {
  case 'a': 
    newX = "addon";
    break;
  case 'b': 
    newX = "base";
    break;
}
var oldX = window.oldX ? window.oldX : "";
window.oldX = newX;
if (x !== newX && oldX.length < x.length) {
	console.log({x: x, new: newX, old: oldX});
  set('x', 'value', newX);
}
*/
`,
};
